import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import 'reflect-metadata';
export var Reflector = /*#__PURE__*/function () {
  function Reflector() {
    _classCallCheck(this, Reflector);
  }

  _createClass(Reflector, null, [{
    key: "addCatchDecoratorMetadata",
    value: function addCatchDecoratorMetadata(Target, error) {
      Reflect.defineMetadata('self:decorators:catch', error, Target);
    }
  }, {
    key: "getCatchDecoratorMetadata",
    value: function getCatchDecoratorMetadata(Target) {
      return Reflect.getMetadata('self:decorators:catch', Target);
    }
  }, {
    key: "addUseErrorHandlersDecoratorMetadata",
    value: function addUseErrorHandlersDecoratorMetadata(Target, handlers) {
      Reflect.defineMetadata('self:decorators:useerrorhandlers', handlers, Target);
    }
  }, {
    key: "getUseErrorHandlersDecoratorMetadata",
    value: function getUseErrorHandlersDecoratorMetadata(Target) {
      var _Reflect$getMetadata;

      return (_Reflect$getMetadata = Reflect.getMetadata('self:decorators:useerrorhandlers', Target)) !== null && _Reflect$getMetadata !== void 0 ? _Reflect$getMetadata : [];
    }
  }]);

  return Reflector;
}();